export const marketStrings = {
  admin: "a",
  active_collateral: "acc",
  activate_market: "am",
  asset_id: "ai",
  bank_asset_id: "ba",
  bank_circulation: "bc",
  bank_to_underlying_exchange: "bt",
  borrow_index: "bi",
  base_interest_rate: "bir",
  contract_update_time: "cut",
  collateral_factor: "cf",
  implied_borrow_index: "i",
  increase_param_update_delay: "ipud",
  is_active: "ia",
  is_disabled_supply: "ids",
  is_disabled_borrow: "idb",
  is_final_params: "ifp",
  is_final_contract: "ifc",
  latest_time: "lt",
  liquidation_incentive: "li",
  manager_id: "mi",
  manager_market_counter_var: "mm",
  market_activation_time: "ma",
  market_supply_cap_in_dollars: "msc",
  market_borrow_cap_in_dollars: "mbc",
  min_scheduled_param_update_delay: "mpud",
  outstanding_borrow_shares: "ob",
  oracle_app_id: "o",
  oracle_price_field: "op",
  oracle_price_scale_factor: "ops",
  reserve_factor: "rf",
  new_collateral_factor: "ncf",
  new_liquidation_incentive: "nl",
  new_reserve_factor: "nr",
  new_utilization_optimal: "nu",
  new_base_interest_rate: "nb",
  new_slope_1: "ns",
  new_slope_2: "ns2",
  new_oracle_app_id: "no",
  new_oracle_price_field: "nop",
  new_oracle_price_scale_factor: "nops",
  new_market_supply_cap_in_dollars: "nmsc",
  new_market_borrow_cap_in_dollars: "nmbc",
  param_update_time: "put",
  remove_reserves: "rr",
  schedule_contract_update: "scu",
  schedule_market_params_update: "sm",
  set_market_params: "smp",
  set_is_final_params: "sifp",
  set_is_final_contract: "sifc",
  set_is_disabled_supply: "sids",
  set_is_enabled_supply: "sies",
  set_is_disabled_borrow: "sidb",
  set_is_enabled_borrow: "sieb",
  slope_1: "s1",
  slope_2: "s2",
  total_borrow_interest_rate: "tbir",
  transfer_admin: "ta",
  underlying_cash: "uc",
  underlying_borrowed: "ub",
  underlying_reserves: "ur",
  utilization_optimal: "uo",
  variable_interest_rate: "vir",
  update_market_params: "ump",
  // user variables
  user_active_collateral: "uac",
  user_borrow_shares: "ubs"
}
export const managerStrings = {
  add_collateral: "ac",
  admin: "a",
  borrow: "b",
  burn: "bu",
  contract_update_time: "cut",
  counter_indexed_rewards_coefficient: "_ci",
  claim_rewards: "cr",
  disable_rewards_program: "drp",
  fetch_market_variables: "fmv",
  is_finalized: "if",
  latest_rewards_time: "lrt",
  liquidate: "l",
  mint: "m",
  mint_to_collateral: "mt",
  n_rewards_programs: "nrp",
  opt_into_asset: "oia",
  rewards_amount: "ra",
  rewards_asset_id: "rai",
  rewards_bitmap: "rbm",
  rewards_per_second: "rp",
  rewards_secondary_asset_id: "rsai",
  rewards_secondary_ratio: "rsr",
  rewards_start_time: "rst",
  supported_market_count: "smc",
  price_string: "_p",
  remove_collateral: "rc",
  remove_collateral_underlying: "rcu",
  repay_borrow: "rb",
  schedule_contract_update: "scu",
  storage_opt_in: "so",
  set_is_final: "sif",
  set_rewards_program: "srp",
  set_supported_market_count: "ssmc",
  transfer_admin: "ta",
  update_prices: "up",
  update_protocol_data: "upd",
  update_rewards_program: "urp",
  // user variables
  user_global_max_borrow_in_dollars: "ug",
  user_global_borrowed_in_dollars: "ugb",
  user_address: "ua",
  user_storage_address: "usa",
  user_rewards_latest_time: "urlt",
  user_rewards_program_number: "urpn",
  user_pending_rewards: "upr",
  user_secondary_pending_rewards: "us",
  counter_to_user_rewards_coefficient_initial: "_uc"
}
